export const EXAM = "exam";
export const CONSULTATION = "consultation";
